import { routes } from "@/utils/constants";

export const NAVBAR_ITEMS = [
  { label: "ORDERS", path: routes.order },
  { label: "READY ORDERS", path: routes.readyOrder },
];
